export default __webpack_public_path__ + "static/media/survey.dc711ebd.svg";